module.exports = __webpack_public_path__ + "static/media/drawer-texts-off.027b5e22.png";